<template>
  <div v-if="visible && batch.length" class="ps-upload-panel" :class="{ collapsed: collapsed }">
    <div class="ps-upload-panel__header" @click="collapsed = !collapsed">
      <span class="ps-upload-panel__title">
        <i v-if="summary.inProgress" class="el-icon-loading"></i>
        <i v-else-if="summary.failed" class="el-icon-warning ps-icon--failed"></i>
        <i v-else class="el-icon-circle-check ps-icon--ok"></i>
        {{ headerText }}
      </span>
      <span class="ps-upload-panel__actions">
        <i :class="collapsed ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" :title="collapsed ? 'Expand' : 'Collapse'"></i>
        <i
          v-if="!summary.inProgress"
          class="el-icon-close ps-upload-panel__close"
          title="Dismiss"
          @click.stop="dismiss"></i>
      </span>
    </div>
    <ul v-show="!collapsed" class="ps-upload-panel__list">
      <li v-for="file in batch" :key="file.log_id" class="ps-upload-panel__item" :class="statusClass(file.status)">
        <i class="ps-upload-panel__status" :class="statusIcon(file.status)"></i>
        <span class="ps-upload-panel__name" :title="file.file_name">{{ file.file_name || 'Untitled document' }}</span>
        <span
          v-if="file.status === 'FAILED' && file.info"
          class="ps-upload-panel__info"
          :title="file.info">{{ file.info }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'ProscanUploadBatchPanel',
    data () {
      return {
        collapsed: false
      }
    },
    computed: {
      ...mapGetters({
        batch: 'getProscanUploadBatch',
        visible: 'getProscanUploadBatchVisible',
        summary: 'getProscanUploadBatchSummary'
      }),
      headerText () {
        const { total, inProgress, successful, failed } = this.summary
        if (inProgress) {
          return `Uploading ${inProgress} of ${total}…`
        }
        const parts = []
        if (successful) parts.push(`${successful} done`)
        if (failed) parts.push(`${failed} failed`)
        return `Upload complete — ${parts.join(', ')}`
      }
    },
    watch: {
      // Expand automatically when a batch finishes with failures, so the user sees which files.
      summary (next, prev) {
        if (prev && prev.inProgress && !next.inProgress && next.failed) {
          this.collapsed = false
        }
      }
    },
    methods: {
      statusClass (status) {
        if (status === 'FAILED') return 'is-failed'
        if (status === 'SUCCESSFUL') return 'is-ok'
        return 'is-pending'
      },
      statusIcon (status) {
        if (status === 'FAILED') return 'el-icon-warning'
        if (status === 'SUCCESSFUL') return 'el-icon-circle-check'
        return 'el-icon-loading'
      },
      dismiss () {
        this.$store.dispatch('clearProscanUploadBatch')
      }
    },
    created () {
      this.$store.dispatch('resumeProscanUploadBatch')
    }
  }
</script>

<style scoped>
  .ps-upload-panel {
    position: fixed;
    right: 20px;
    bottom: 20px;
    width: 340px;
    max-width: calc(100vw - 40px);
    background: #fff;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
    z-index: 3000;
    font-size: 13px;
  }
  .ps-upload-panel__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 12px;
    cursor: pointer;
    background: #f5f7fa;
    border-bottom: 1px solid #ebeef5;
    border-radius: 4px 4px 0 0;
  }
  .ps-upload-panel.collapsed .ps-upload-panel__header {
    border-bottom: none;
  }
  .ps-upload-panel__title {
    font-weight: 600;
    color: #303133;
    display: flex;
    align-items: center;
  }
  .ps-upload-panel__title i {
    margin-right: 6px;
  }
  .ps-upload-panel__actions i {
    margin-left: 8px;
    color: #909399;
  }
  .ps-upload-panel__close:hover {
    color: #f56c6c;
  }
  .ps-icon--ok {
    color: #67c23a;
  }
  .ps-icon--failed {
    color: #f56c6c;
  }
  .ps-upload-panel__list {
    list-style: none;
    margin: 0;
    padding: 4px 0;
    max-height: 260px;
    overflow-y: auto;
  }
  .ps-upload-panel__item {
    display: flex;
    align-items: center;
    padding: 6px 12px;
    line-height: 1.3;
  }
  .ps-upload-panel__status {
    margin-right: 8px;
    flex: 0 0 auto;
  }
  .ps-upload-panel__item.is-ok .ps-upload-panel__status {
    color: #67c23a;
  }
  .ps-upload-panel__item.is-failed .ps-upload-panel__status {
    color: #f56c6c;
  }
  .ps-upload-panel__item.is-pending .ps-upload-panel__status {
    color: #909399;
  }
  .ps-upload-panel__name {
    flex: 1 1 auto;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #303133;
  }
  .ps-upload-panel__info {
    flex: 0 1 auto;
    margin-left: 8px;
    color: #f56c6c;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 45%;
  }
</style>



// WEBPACK FOOTER //
// src/components/RouteComponents/Proscan/ProscanUploadBatchPanel.vue